import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function RiskSetting() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [loading, setLoading] = useState(true)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clickData, setClickData] = useState([]) // 현재 선택된(수정 중인) 가맹점 데이터
    const [reload, setReload] = useState(false)

    const [listState, setListState] = useState(false)

    const [inputValues, setInputValues] = useState([]);

    useEffect(() => {
        if (listData?.length > 0) {
            const mapped = listData.map((item) => ({
                setting_key: item.setting_key,
                setting_value: item.setting_value,
            }));
            setInputValues(mapped);
        }
    }, [listData]);

    useEffect(() => {
        if (listData?.length) {
            setInputValues(listData.map((item) => ({ setting_key: item.setting_key, setting_value: item.setting_value })));
        }
    }, [listData]);

    const handleInputChange = (key, value) => {
        setInputValues((prev) =>
            prev.map((item) =>
                item.setting_key === key
                    ? { ...item, setting_value: value }
                    : item
            )
        );
    };

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("RM설정"))
        dispatch(changeHeaderTitle({
            mainTitle: "RM설정"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    useEffect(() => {
        ListData()
    }, [reload])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/rm/settings", {
            withCredentials: true,
            params: {
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data?.settings ?? [])
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData =
        [
            { "no": 1, "text": "설정 목록", "width": "200px", "textAlign": "center" },
            { "no": 2, "text": "설정 값", "width": "100px", "textAlign": "center" },
        ]

    useEffect(() => {
        let tableBodyData = [];

        if (listData.length > 0) {
            const inputStyle = {
                padding: '0 10px',
                fontSize: '12px',
                width: '100%',
                height: '30px',
                boxSizing: 'border-box',
                textAlign: "center",
                border: "1px solid rgb(13 148 136 / 1)",
                borderRadius: '4px'
            };

            for (let i = 0; i < listData.length; i++) {
                let data = listData[i];

                let row = [];
                row.id = data.id;

                row.push({
                    no: 1,
                    text: data.description,
                    width: "200px",
                    textAlign: "left"
                });
                
                row.push({
                    no: 2,
                    text: (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "80%" }}>
                            <input
                                type="text"
                                style={inputStyle}
                                value={
                                    inputValues.find(v => v.setting_key === data.setting_key)?.setting_value || ""
                                }
                                onChange={(e) =>
                                    handleInputChange(data.setting_key, e.target.value)
                                }
                            />
                        </div>
                    ),
                    width: "100px",
                    textAlign: "left"
                });

                tableBodyData.push(row);
            }

            setCombineData(tableBodyData);
            setListState(e => !e);
        }
    }, [listData, inputValues]);

    const onSubmit = async () => {
        if (window.confirm("설정값을 수정하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + "/api/rm/settings/bulk", {
                settings: inputValues
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data;
                console.log(tmp)
                if (tmp?.code < 2000) {
                    setReload(e => !e);
                }
            }).catch(error => {
                console.error(error);
            });
        }
    };

    const handleCancel = () => {
        setInputValues(
            listData.map((item) => ({
                setting_key: item.setting_key,
                setting_value: item.setting_value,
            }))
        );
    };

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                    />
                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                    <div style={{ width: "100%", maxWidth: "300px" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.totCnt ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            nonePage={true}
                            maxFirstPage={maxFirstPage}
                            clickData={clickData}
                            listType={true}
                            listState={listState}
                        />
                        <div className="intro-y">
                            <div className="text-right" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px" }}>
                                <button
                                    className="btn btn-primary"
                                    onClick={onSubmit}
                                    style={{ padding: '10px 20px' }}
                                >
                                    수정
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={handleCancel}
                                    style={{ padding: '10px 20px' }}
                                >
                                    취소
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RiskSetting